export default {
    RELOAD_APP: 'RELOAD_APP',
    RECONNECT_DEVICE: 'RECONNECT_DEVICE',
    RECONNECT_DEVICE_KIT: 'RECONNECT_DEVICE_KIT',
    SHOW_RECONNECT_GUIDE: 'SHOW_RECONNECT_GUIDE',
    DEVICE_LOCK: 'DEVICE_LOCK',
    FIRMWARE_UPDATE_COMPLETED: 'FIRMWARE_UPDATE_COMPLETED',
    UNDO_REMOVE_NETWORK: 'UNDO_REMOVE_NETWORK',
    CLOSE: 'CLOSE',
    UNDO_REMOVE_NOTIFICATION: 'UNDO_REMOVE_NOTIFICATION',
};
